/**
 * Exhaustiveness guard for the contract's string unions (deal state, line type,
 * schedule status, ...). Calling it in a `switch`'s default makes adding a value
 * to a `@crm/shared` enum a COMPILE error in every place the UI renders it,
 * rather than a silently blank cell discovered by a reader of a report.
 */
export function assertNever(value: never, context: string): never {
  throw new Error(`Unhandled ${context}: ${JSON.stringify(value)}`);
}
